<template>
  <v-container fluid class="pa-4">
    <v-card v-if="isSuperAdmin" class="pa-4" style="border-radius: 14px;">
      <div class="text-h6 font-weight-bold mb-1">Amallarni cheklash</div>
      <div class="text-body-2 grey--text mb-4">
        Ayrim amallarni (masalan Excel yuklab olish) vaqtinchalik o'chirib qo'yish. Yoqilgan
        cheklov barcha foydalanuvchilarga ta'sir qiladi.
      </div>

      <v-progress-linear v-if="loading" indeterminate rounded class="mb-3" />

      <v-card
        v-for="item in items"
        :key="item.settingKey"
        outlined
        class="mb-3 pa-4"
        style="border-radius: 12px;"
      >
        <div class="d-flex align-start justify-space-between">
          <div class="pr-4">
            <div class="font-weight-medium">
              {{ item.title || item.settingKey }}
              <v-chip
                x-small
                label
                :color="item.enabled ? 'error' : 'success'"
                outlined
                class="ml-2"
              >
                {{ item.enabled ? "Cheklangan" : "Faol" }}
              </v-chip>
            </div>
            <div class="text-caption grey--text mt-1" style="white-space: pre-line;">
              {{ item.description }}
            </div>
          </div>
          <v-switch
            :input-value="item.enabled"
            :loading="savingKey === item.settingKey"
            :disabled="savingKey === item.settingKey"
            hide-details
            inset
            color="error"
            class="mt-0"
            @change="(val) => onToggle(item, val)"
          />
        </div>
      </v-card>

      <div v-if="!loading && !items.length" class="text-body-2 grey--text text-center py-6">
        Cheklash uchun amallar mavjud emas.
      </div>
    </v-card>

    <v-card v-else class="pa-6 text-center" style="border-radius: 14px;">
      <div class="text-h6 font-weight-bold mb-1">Ruxsat yo'q</div>
      <div class="text-body-2 grey--text">
        Bu bo'lim faqat super adminlar uchun.
      </div>
    </v-card>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: "AdminActionRestrictions",
  data: () => ({
    loading: false,
    savingKey: null,
  }),
  computed: {
    ...mapGetters("auth", ["GET_USER"]),
    ...mapGetters("app-settings", ["GET_APP_SETTINGS"]),
    user: (vm) => vm.GET_USER,
    isSuperAdmin: (vm) => !!vm.user && vm.user.role === "ADMIN_SUPER",
    items: (vm) => vm.GET_APP_SETTINGS,
  },
  created() {
    if (this.isSuperAdmin) this.fetch();
  },
  methods: {
    ...mapActions("app-settings", ["INIT_APP_SETTINGS", "UPDATE_APP_SETTING"]),
    async fetch() {
      this.loading = true;
      await this.INIT_APP_SETTINGS();
      this.loading = false;
    },
    async onToggle(item, val) {
      this.savingKey = item.settingKey;
      const ok = await this.UPDATE_APP_SETTING({
        key: item.settingKey,
        enabled: val,
      });
      this.savingKey = null;
      this.notify(ok);
      // Re-fetch so the global getter (and every Excel button) reflects the new value,
      // and the switch reverts if the save failed.
      await this.fetch();
    },
    notify(ok) {
      this.$store.dispatch("SET_SNACKBAR", {
        text: ok ? "Saqlandi" : "Xatolik yuz berdi",
        color: ok ? "success" : "error",
      });
    },
  },
};
</script>
